import React from "react";
import Tooltip from "@mui/material/Tooltip";

export default function copyableCell(params, baseColor = "#28292bff") {
  const [copied, setCopied] = React.useState(false);

  return (
    <Tooltip title={copied ? "Copied!" : "Click to copy"}>
      <span
        onClick={() => {
          navigator.clipboard.writeText(params.value);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        }}
        style={{
          cursor: "pointer",
          color: copied ? "green" : baseColor,
        }}
      >
        {params.value}
      </span>
    </Tooltip>
  );
}
